import { Routes } from '@angular/router';
import {
  AuthGuard,
  GENERAL_CONSTANTS,
  HowdenWithoutMenuLayoutComponent,
  NOT_AUTHORIZED_ROUTING,
  NOT_FOUND_ROUTING,
  NotAuthorizedComponent
} from '@howdeniberia/core-front';
import { CredentialsPageComponent } from './features/credentials/pages/credentials-page/credentials-page.component';

export const AppRoutes = [
  {
    path: '',
    component: HowdenWithoutMenuLayoutComponent,
    canActivate: [AuthGuard],
    data: {
      isLayout: true,
      roles: ['HowdenClavesCiasAdmin', 'HowdenClavesCiasBasic']
    },
    children: [
      {
        path: '',
        component: CredentialsPageComponent,
        title: $localize`:@@app.route.main:Credentials List`
      }
    ]
  },
  {
    path: GENERAL_CONSTANTS.NotAuthorizedUrl,
    title: $localize`:@@app.route.notauthorized: No autorizado`,
    component: NotAuthorizedComponent
  },
  NOT_AUTHORIZED_ROUTING,
  NOT_FOUND_ROUTING,
  { path: '**', redirectTo: '404' }
] as Routes;
